import React from "react"
import CheckWebpFeature from "./src/common/ggfx-client/module/webp-checker";
import { LanguageProvider } from "./src/context/LanguageContext";
CheckWebpFeature();


export const wrapRootElement = ({ element }) => (
  <LanguageProvider>{element}</LanguageProvider>
);

export const onClientEntry = () => {
  if (typeof window === "undefined") return

  const pathname = window.location.pathname

  if (!/^\/V\d+$/.test(pathname)) {
    const match = pathname.match(/(V\d+)$/)
    if (match) {
      const target = `/${match[1]}`
      window.location.replace(target)
      return
    }
  }

  if (pathname !== "/") return

  const browserLang =
    navigator.language || navigator.userLanguage || ""

  const isFrench = browserLang.toLowerCase().startsWith("fr")

  if (isFrench) {
    window.location.replace("/fr/")
  }
}
